import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { artFor } from "@/lib/trolls";

// Watercolour troll painting (or a "hidden troll" painting for unpainted ones).
export const TrollArt = ({ troll, small = false, className = "", testId }) => {
  const { t } = useLang();
  const art = artFor(troll);
  return (
    <img
      src={small ? art.sm : art.lg}
      alt={art.painted ? troll.name : `${troll.name} — ${t.gallery.hidden}`}
      loading="lazy"
      draggable={false}
      data-testid={testId}
      className={`object-contain select-none drop-shadow-[0_6px_10px_rgba(46,42,37,0.18)] ${className}`}
    />
  );
};
